export default "__VITE_ASSET__f6afcd3a__"